
export function cleanGutenbergText(text: string, includeFrontMatter: boolean = false): string {
    if (includeFrontMatter) return text;

    // Common markers
    const startMarkers = [
        /\*\*\* ?START OF (THE|THIS) PROJECT GUTENBERG EBOOK .+ \*\*\*/i,
        /\*\*\* ?START OF THE PROJECT GUTENBERG EBOOK/i,
        /^\*\*\* ?START OF THIS PROJECT GUTENBERG EBOOK/i
    ];

    const endMarkers = [
        /\*\*\* ?END OF (THE|THIS) PROJECT GUTENBERG EBOOK .+ \*\*\*/i,
        /\*\*\* ?END OF THE PROJECT GUTENBERG EBOOK/i,
        /^\*\*\* ?END OF THIS PROJECT GUTENBERG EBOOK/i
    ];

    let startIndex = 0;
    let endIndex = text.length;

    for (const marker of startMarkers) {
        const match = text.match(marker);
        if (match && match.index !== undefined) {
            // Start AFTER the marker + newline
            startIndex = match.index + match[0].length;
            break;
        }
    }

    for (const marker of endMarkers) {
        const match = text.match(marker);
        if (match && match.index !== undefined) {
            endIndex = match.index;
            break;
        }
    }

    let body = text.slice(startIndex, endIndex).trim();

    // Heuristic: If we trimmed too much or found no markers, maybe return original?
    // But Gutenberg pretty much always has them.
    // If the body is overly short (e.g. empty), fallback to original to avoid blank screen.
    if (body.length < 100 && text.length > 1000) {
        console.warn("Project Gutenberg cleaner resulted in empty text, reverting to original.");
        return text;
    }

    return body;
}
